/**
*  The abstractSingleValueInput mixin
*  @module framework/mixins/abstractSingleValueInput
*/

import abstractInput from './abstractInput';
import { mix, } from '../instance/mix';
import { isFunction, } from '../instance/utils';

/**
* Extends abstractInput with properties that are useful for input elements that represent a single
* value.
* @mixes framework/mixins/abstractInput
* @mixin
*/
export default mix({}, abstractInput, {
    data() {
        return {
            /**
             * The data model for a singular component
            */
            componentValue: '',
        };
    },
    /**
     * The properties for this component.
     */
    computed: {
        /**
         * The data interface for all components.
         */
        value: {
            get() {
                let val = this.componentValue;
                if (isFunction(this.format)) {
                    val = this.format(val);
                }

                return val;
            },

            set(newValue) {
                let val = newValue;

                if (isFunction(this.parse)) {
                    val = this.parse(val);
                }

                if (isFunction(this.isBuildingValue)) {
                    if (this.isBuildingValue(val)) {
                        return;
                    }
                }

                this.componentValue = val;

                if (this.isNested) {
                    // broadcast event that data has changed
                    // This event is caught by a parent that wants to aggregate its
                    // changed value into a complex component
                    this.$emit('dataChanged', this.componentValue);

                    return;
                }

                // if this component is nested, we pass the value up to its parent(see above).
                // if not nested, we put it onto the global manifest.
                if (this.nodeManifest) {
                    let noValue = false;
                    let valueChanged = false;
                    if (this.nodeManifest.values.length === 0) {
                        noValue = true;
                    } else if (this.nodeManifest.values[0].value !== this.componentValue) {
                        // has a value and it is different than the current value
                        valueChanged = true;
                    }

                    if (noValue || valueChanged) {
                        this.setValueToManifest({
                            value: this.componentValue,
                        });
                    }
                }
            },
        },
    },
    /**
     * The methods for this component.
     */
    methods: {
        /**
         * Get the values(if it exists yet) from manifest
         * @returns {void}
         */
        setComponentValueFromManifest() {
            this.componentValue = this.nodeManifest.values[0].value;
        },
        /**
        * Gets the error information off of the input element(s)
        * @param {string} tagName the name of input tag.
        * @returns {void}
        */
        getSimpleErrorStateOffInputs(tagName) {
            let validationObject = this.$el.querySelector(tagName).validity;
            let validationMessage = this.$el.querySelector(tagName).validationMessage;
            return {
                validationObject,
                validationMessage,
            };
        },
    },
});



// WEBPACK FOOTER //
// ./source/framework/mixins/abstractSingleValueInput.js